import { render } from "./BracketsPlusIcon.vue?vue&type=template&id=b36caab8"
import script from "./BracketsPlusIcon.vue?vue&type=script&lang=js"
export * from "./BracketsPlusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__